import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom"
import { AuthProvider } from "@/contexts/AuthContext"
import { ProtectedRoute } from "@/components/ProtectedRoute"
import { AdminRoute } from "@/components/AdminRoute"
import { AppSidebar } from "@/components/AppSidebar"
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { Toaster } from "@/components/ui/sonner"
import Dashboard from "@/pages/Dashboard"
import Avaliacoes from "@/pages/Avaliacoes"
import Avaliacao360 from "@/pages/Avaliacao360"
import AvaliacaoPosicoes from "@/pages/AvaliacaoPosicoes"
import Veiculos from "@/pages/Veiculos"
import VeiculoDetalhes from "@/pages/VeiculoDetalhes"
import NotFound from "@/pages/NotFound"
import NovoVeiculo from "@/pages/NovoVeiculo"
import EditarVeiculo from "@/pages/EditarVeiculo"
import PropostaDetalhes from "@/pages/PropostaDetalhes"
import PropostasConcluidas from "@/pages/PropostasConcluidas"
import Relatorios from "@/pages/Relatorios"
import Configuracoes from "@/pages/Configuracoes"
import ConsultaPlaca from "@/pages/ConsultaPlaca"
import Login from "@/pages/Login"
import Cadastro from "@/pages/Cadastro"
import EsqueciSenha from "@/pages/EsqueciSenha"
import RedefinirSenha from "@/pages/RedefinirSenha"
import Planos from "@/pages/Planos"
import Usuarios from "@/pages/Usuarios"
import TermosDeUso from "@/pages/TermosDeUso"
import PoliticaPrivacidade from "@/pages/PoliticaPrivacidade"
import Landing from "@/pages/Landing"
import TermoPublico from "@/pages/TermoPublico"
import PropostaPublica from "@/pages/PropostaPublica"
import Diagnostico from "@/pages/Diagnostico"
import DiagnosticoPublico from "@/pages/DiagnosticoPublico"
import Diagnosticos from "@/pages/Diagnosticos"
import AssistenteIA from "@/pages/AssistenteIA"
import { AssistenteVozGlobal } from "@/components/ai/AssistenteVozGlobal"

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Rotas públicas */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/esqueci-senha" element={<EsqueciSenha />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route path="/planos" element={<Planos />} />
          <Route path="/termos-de-uso" element={<TermosDeUso />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/t/:token" element={<TermoPublico />} />
          <Route path="/p/:token" element={<PropostaPublica />} />
          <Route path="/d/:token" element={<DiagnosticoPublico />} />

          {/* Rotas protegidas (todos os papéis) */}
          <Route element={<ProtectedRoute />}>
            <Route element={<SidebarLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/assistente-ia" element={<AssistenteIA />} />
              <Route path="/avaliacoes" element={<Avaliacoes />} />
              <Route path="/nova-avaliacao" element={<Navigate to="/veiculos" replace />} />
              <Route path="/avaliacao/:id" element={<Avaliacao360 />} />
              <Route path="/avaliacao-posicoes/:id" element={<AvaliacaoPosicoes />} />
              <Route path="/veiculos" element={<Veiculos />} />
              <Route path="/veiculo/:id" element={<VeiculoDetalhes />} />
              <Route path="/novo-veiculo" element={<NovoVeiculo />} />
              <Route path="/editar-veiculo/:id" element={<EditarVeiculo />} />
              <Route path="/proposta/:id" element={<PropostaDetalhes />} />
              <Route path="/diagnostico/novo" element={<Diagnostico />} />
              <Route path="/diagnostico/:id" element={<Diagnostico />} />
              <Route path="/diagnosticos" element={<Diagnosticos />} />
              <Route path="/propostas" element={<PropostasConcluidas />} />
              <Route path="/propostas-concluidas" element={<PropostasConcluidas />} />
              <Route path="/consulta-placa" element={<ConsultaPlaca />} />
              <Route path="/configuracoes" element={<Configuracoes />} />

              {/* Rotas exclusivas admin */}
              <Route element={<AdminRoute />}>
                <Route path="/relatorios" element={<Relatorios />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Routes>
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  )
}

function SidebarLayout() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-transparent">
        <AppSidebar />
        <SidebarInset>
          <main className="flex-1 px-3 py-4 sm:p-4 md:p-6 lg:p-8">
            <Outlet />
          </main>
        </SidebarInset>
      </div>
      <AssistenteVozGlobal />
    </SidebarProvider>
  )
}

export default App
